@import 'styles/blaze/mixins';
@import 'styles/variables';
@import 'styles/mixins';

.root {
  @include blur;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: var(--editor-top);

  .title {
    color: var(--dark-100);
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 120%;
    @include md-sohne-medium;
  }

  .topBarContainer {
    display: grid;
    padding: 5px;
    width: 100%;
    grid-template-columns: 1fr auto 1fr;
    margin-bottom: 10px;
  }

  .titleContainer {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 6px 6px 6px 0px;
  }

  .stepperContainer {
    align-self: stretch;
    display: flex;
    justify-content: space-around;
    position: relative;
    padding: 0 10px 10px 10px;
    max-width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    --active-step-color: var(--dark-100);
    --step-color: var(--dark-60);
    --badge-color: var(--editor-top);
  }

  .stepperContainer::-webkit-scrollbar {
    display: none;
  }
}

.stepContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 2px 0;

  &.pressable {
    cursor: pointer;
  }
}

.step {
  border-radius: 12px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  @include sm-sohne-medium;
  color: var(--dark-60);
  gap: 2px;
  font-size: 13px;
  font-weight: 400;

  &.active {
    background-color: transparent;
    color: var(--dark-100);
  }
}

.cancelContainer {
  margin-left: auto;
}
